const empty = { item_name:'', description:'', quantity:1, unit_price:0, tax_percent:18 };

export default function ItemsEditor({ items, setItems }) {
  const add = () => setItems([...items, { ...empty }]);
  const rm  = (i) => setItems(items.filter((_,idx) => idx !== i));
  const set = (i, f, v) => setItems(items.map((it,idx) => idx===i ? {...it,[f]:v} : it));

  const sub  = items.reduce((s,i) => s + i.quantity*i.unit_price, 0);
  const tax  = items.reduce((s,i) => s + i.quantity*i.unit_price*(i.tax_percent/100), 0);
  const line = (i) => i.quantity*i.unit_price*(1+i.tax_percent/100);

  return (
    <div>
      <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:10 }}>
        <div className="card-title">Line Items *</div>
        <button type="button" className="btn btn-sm btn-secondary" onClick={add}>+ Add Row</button>
      </div>
      <div style={{ overflowX:'auto',background:'var(--bg4)',borderRadius:'var(--r)',border:'1px solid var(--border)' }}>
        <table className="items-table" style={{ minWidth:580 }}>
          <thead>
            <tr>
              <th style={{ width:'28%' }}>Item Name</th>
              <th style={{ width:'20%' }}>Description</th>
              <th style={{ width:'9%'  }}>Qty</th>
              <th style={{ width:'14%' }}>Unit Price</th>
              <th style={{ width:'9%'  }}>Tax %</th>
              <th style={{ width:'13%' }}>Total</th>
              <th style={{ width:'7%'  }}></th>
            </tr>
          </thead>
          <tbody>
            {items.map((it,i) => (
              <tr key={i} style={{ background: i%2===0?'transparent':'rgba(128,128,128,.03)' }}>
                <td style={{ padding:'5px 6px' }}><input value={it.item_name} onChange={e=>set(i,'item_name',e.target.value)} placeholder="Item name *" required /></td>
                <td style={{ padding:'5px 3px' }}><input value={it.description||''} onChange={e=>set(i,'description',e.target.value)} placeholder="Details…" /></td>
                <td style={{ padding:'5px 3px' }}><input type="number" min=".01" step=".01" value={it.quantity} onChange={e=>set(i,'quantity',parseFloat(e.target.value)||0)} /></td>
                <td style={{ padding:'5px 3px' }}><input type="number" min="0" step=".01" value={it.unit_price} onChange={e=>set(i,'unit_price',parseFloat(e.target.value)||0)} /></td>
                <td style={{ padding:'5px 3px' }}><input type="number" min="0" max="100" step=".1" value={it.tax_percent} onChange={e=>set(i,'tax_percent',parseFloat(e.target.value)||0)} /></td>
                <td style={{ padding:'5px 8px',fontWeight:600,color:'var(--text)',fontSize:12.5 }}>₹{line(it).toLocaleString('en-IN',{minimumFractionDigits:2})}</td>
                <td style={{ padding:'5px 3px',textAlign:'center' }}>
                  <button type="button" onClick={()=>rm(i)} style={{ background:'none',border:'none',color:'var(--err)',cursor:'pointer',fontSize:15,padding:'2px 6px' }}>✕</button>
                </td>
              </tr>
            ))}
            {items.length===0 && <tr><td colSpan={7} style={{ padding:20,textAlign:'center',color:'var(--text3)',fontSize:13 }}>No items — click "+ Add Row"</td></tr>}
          </tbody>
        </table>
      </div>
      <div style={{ display:'flex',justifyContent:'flex-end',marginTop:10 }}>
        <div style={{ background:'var(--bg4)',border:'1px solid var(--border)',borderRadius:'var(--r)',padding:'10px 18px',minWidth:190 }}>
          {[['Subtotal',`₹${sub.toFixed(2)}`],['Tax',`₹${tax.toFixed(2)}`]].map(([l,v])=>(
            <div key={l} style={{ display:'flex',justifyContent:'space-between',gap:28,fontSize:12.5,marginBottom:5,color:'var(--text2)' }}>
              <span>{l}</span><span>{v}</span>
            </div>
          ))}
          <div style={{ display:'flex',justifyContent:'space-between',gap:28,fontSize:14,fontWeight:800,paddingTop:7,borderTop:'1px solid var(--border)',color:'var(--accent2)' }}>
            <span>Total</span><span>₹{(sub+tax).toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
